<template>
<div class="homeView">
  <!-- <big-screen></big-screen> -->
  <!-- <button type=""></button> -->
  <!-- <button type="primary" class="primaryBtn">全屏</button> -->

  <!-- <div class="top">
    <div class="left"></div>
    <div class="center1"></div>
    <div class="right">
      <i v-if="rolePermit('home:edit')" class="el-icon-finished save" title="保存配置" @click="saveConfig"></i>
      <i class="el-icon-circle-close close" title="退出预览" @click="logOut"></i>
    </div>
    <div class="center" :style="{backgroundImage:'url('+require('@/assets/img/use/homeConfig/centerBack.png')+')'}">
      {{systemName}}
    </div>
  </div> -->
  <!-- 大屏头部 -->
  <div class="top">
    <div class="title">{{systemName}}</div>
    <div class="top-right">
      <i v-if="rolePermit('home:edit')" class="el-icon-finished save" title="保存配置" @click="saveConfig"></i>
      <i class="el-icon-circle-close close" title="退出预览" @click="logOut"></i>
    </div>
  </div>
  <div id="map_container"></div>
  <div class="dragCon">
    <div class="dragConCon">
      <transition-group tag="div" class="container">
        <div class="item" v-for="item in checkedItems" :key="item.id" draggable="true" @dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)" @dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)">
          <img :src="require(`@/assets/img/use/homeConfig/${item.imgName}.png`)" alt="">
        </div>
      </transition-group>
    </div>
  </div>
  <ul class="total-center">
    <li v-for="(item, i) in centerPars" :key="i">
      <img :src="item.icon" />
      <div class="right">
        <p>{{item.label}}</p>
        <p class="num" :style="{color: item.color}">{{item.number}}</p>
      </div>
    </li>
  </ul>
  <!-- <div class="mainCenter">
    <li v-for="(item,i) in centerPars" :key="i">
      <span class="centerTop">
        {{item.label}}
      </span>
      <span class="centerBottom">
        {{item.number}}
      </span>
    </li>
  </div> -->

  <!-- <span class="viewClass">预览界面</span> -->
</div>
</template>

<script>
import {
  chinaPly
} from '@/assets/json/ChinaPly.json'
export default {
  data() {
    return {
      checkedItems: [],
      checkIds: [],
      dragging: null,
      mapType: "",
      centerPars: [
        {
          label: "设备总数",
          color: '#02D9FD',
          number: 0,
          icon: require('../../assets/img/bigScreen/total-num.png')
        },
        {
          label: "在线设备",
          color: '#02D9FD',
          number: 0,
          icon: require('../../assets/img/bigScreen/total-lineDev.png')
        },
        {
          label: "今日新增",
          color: '#08C091',
          number: 0,
          icon: require('../../assets/img/bigScreen/total-dayAdd.png')
        },
        {
          label: "今日报警",
          color: '#FA0101',
          number: 0,
          icon: require('../../assets/img/bigScreen/total-dayAlarm.png')
        },
        {
          label: "今日故障",
          color: '#FFCE38',
          number: 0,
          icon: require('../../assets/img/bigScreen/tatal-dayDefault.png')
        },
      ],
      chiaData: chinaPly,
      systemName:'',
      markerList: []
    }
  },
  mounted() {
    this.init()
  },
  created() {
    this.mapType = this.storage.getSession('mapType')
    this.getMarker();
  },
  methods: {

    init() {
      this.getStaticData()
      let allConfig = JSON.parse(this.storage.getSession('allConfig'))
      this.checkIds = JSON.parse(this.storage.getSession('checkedItems'))
      this.checkedItems = allConfig.filter(item => {
        return this.checkIds.indexOf(item.id) !== -1
      })
      this.getAreaId()
    },
   /**
     * @Description 地图中间顶部统计数据
     * @Author      YOYO     -             2021-11-23
     * @return      {[type]} [description]
     */
    async getStaticData() {
      const { code, msg, data } = await this.request.post('/front/device/deviceOverallStatistics')
      if (code !== 200) {
        if (code == 500) {
          return this.$message.error(msg)
        }
        return
      }
      let { onlineCount, totalCount, installCount, alarmCount, faultCount } = data
      this.centerPars[0].number = totalCount
      this.centerPars[1].number = onlineCount
      this.centerPars[2].number = installCount
      this.centerPars[3].number = alarmCount
      this.centerPars[4].number = faultCount
    },
    async getAreaId() {
      const {
        code,
        msg,
        data
      } = await this.request.get("/front/system/config/query")
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      let systemNameItem = data.find(item=>item.code=="SYS_NAME")
      this.systemName = systemNameItem.value
      let areaItem = data.find(item => item.type == 3)
      let areaId = areaItem.value.split('_')
      let curId = null
      if (areaId.length == 1) {
        curId = areaId[0]
      } else if (areaId.length == 2) {
        curId = areaId[1]
      }
      this.getPosition(curId)
    },
    async getPosition(curId) {
      const {
        code,
        msg,
        data
      } = await this.request.get(`/front/region/queryRegionById?regionId=${curId}`)
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      } else {
        console.log(`this.`, )
        if (data.city) {
          this.initMap(data.city, data.latitude, data.longitude, this.mapType)
        } else {
          this.initMap(data.province, data.latitude, data.longitude, this.mapType)
        }
      }
    },
    changeShowFlag(state, flag) {
      state.showFlag = flag
    },
    async saveConfig() {
     let enabledOrderedIds = this.checkedItems.map(item=>item.id).join(",")
      let par = {
        enabledOrderedIds,
        mapType: this.storage.getSession('mapType')
      }
      console.log(`par`, par)
      const {
        code,
        msg
      } = await this.request.putParamsData('/front/homepage/editConfig', par)
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      return this.$message.success("编辑成功")
    },
    logOut() {
      // this.$router.push('/homeConfig')
      this.$emit('showClose')
    },
     async getMarker() {
      const {
        code,
        msg,
        data
      } = await this.request.post('/front/device/deviceMapData')
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      this.markerList = data
    },
    // 地图
    initMap(position, latitude, longitude) {
      var map = new BMap.Map("map_container");
      map.centerAndZoom(new BMap.Point(latitude, longitude), 11);
      // map.addControl(new BMap.MapTypeControl({
      //   mapTypes: [BMAP_NORMAL_MAP, BMAP_SATELLITE_MAP],
      //   anchor: BMAP_ANCHOR_TOP_LEFT
      // }))
      map.enableScrollWheelZoom(true);
      let that = this
      var bdary = new BMap.Boundary();
      bdary.get(position, function (rs) { //获取行政区域
        //网上查了下，东西经南北纬的范围
        var EN_JW = "180, 90;"; //东北角
        var NW_JW = "-180,  90;"; //西北角
        var WS_JW = "-180, -90;"; //西南角
        var SE_JW = "180, -90;"; //东南角
        //4.添加环形遮罩层
        var bdaryarr;
        var olength = rs.boundaries.length;
        if (olength > 1) {
          var maxindex = 0;
          var maxlength = rs.boundaries[0].length;
          for (var i = 0; i < olength; i++) {
            var inlength = rs.boundaries[i].length;
            if (inlength > maxlength) {
              maxindex = i;
              maxlength = inlength;
            }
          }
          bdaryarr = rs.boundaries[maxindex];
        } else {
          bdaryarr = rs.boundaries[0];
        }
        if (position == "中国") {
          formatploy = that.chiaData.join(';')
        } else {
          var temp = bdaryarr.split(';');
          var formatploy = bdaryarr + ';' + temp[0];
        }

        var ply1 = new BMap.Polygon(formatploy + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, {
          strokeColor: "none",
          fillColor: "#020C24",
          fillOpacity: 0.9,
          strokeOpacity: 0
        }); //建立多边形覆盖物

        map.addOverlay(ply1);
        //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
        //console.log(`formatploy`, formatploy)
        var ply = new BMap.Polygon(formatploy, {
          strokeWeight: 2,
          strokeColor: "rgb(51,204,255)",
          fillColor: ""
        });
        map.addOverlay(ply);
        map.setViewport(ply.getPath()); //调整视野
      });
      // 区域===========================
      map.setMapStyle({
        styleJson: [{
          "featureType": "water",
          "elementType": "all",
          "stylers": {
            "color": "#044161"
          }
        }, {
          "featureType": "land",
          "elementType": "all",
          "stylers": {
            "color": "#091934"
          }
        }, {
          "featureType": "boundary",
          "elementType": "geometry",
          "stylers": {
            "color": "#064f85"
          }
        }, {
          "featureType": "railway",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "highway",
          "elementType": "geometry",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "highway",
          "elementType": "geometry.fill",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "highway",
          "elementType": "labels",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "arterial",
          "elementType": "geometry",
          "stylers": {
            "color": "#004981",
            "lightness": -39
          }
        }, {
          "featureType": "arterial",
          "elementType": "geometry.fill",
          "stylers": {
            "color": "#00508b"
          }
        }, {
          "featureType": "poi",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "green",
          "elementType": "all",
          "stylers": {
            "color": "#056197",
            "visibility": "off"
          }
        }, {
          "featureType": "subway",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "manmade",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "local",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "arterial",
          "elementType": "labels",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "boundary",
          "elementType": "geometry.fill",
          "stylers": {
            "color": "#029fd4"
          }
        }, {
          "featureType": "building",
          "elementType": "all",
          "stylers": {
            "color": "#1a5787"
          }
        }, {
          "featureType": "label",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": {
            "color": "#ffffff"
          }
        }, {
          "featureType": "poi",
          "elementType": "labels.text.stroke",
          "stylers": {
            "color": "#1e1c1c"
          }
        }, {
          "featureType": "administrative",
          "elementType": "labels",
          "stylers": {
            "visibility": "on"
          }
        }, {
          "featureType": "road",
          "elementType": "labels",
          "stylers": {
            "visibility": "off"
          }
        }]
      });
     
      console.log(`that. this.markerList`, that.markerList)
      var markers = [];
      var pt = null;
      that.markerList.forEach((item, i) => {
        console.log(`item`, item)
        //          if ( i>that.markerList.length/2) {
        //     pt = new BMap.Point(...item.installGps.split(","));
        //     // markers.push(new BMap.Marker(pt, {icon: myIcon}));
        // } else {
        if (item.installGps) {
          pt = new BMap.Point(...item.installGps.split(","));
          var a
          var myIcon
          if(item.typeName.split("_")[0]=='烟感') {
            if (item.isOnline){
               myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/onLineYanGan.png"), new BMap.Size(30, 30), {
              // offset: new BMap.Size(10, 25), // 指定定位位置
              // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
            });
            }else {
               myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/outLineYanGan.png"), new BMap.Size(30, 30), {
              // offset: new BMap.Size(10, 25), // 指定定位位置
              // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
            });
            }
             a = new BMap.Marker(pt, {
              icon: myIcon
            })
          }else if(item.typeName.split("_")[0]=='燃气'){
              if (item.isOnline){
               myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/onLineKeRanQi.png"), new BMap.Size(30, 30), {
              // offset: new BMap.Size(10, 25), // 指定定位位置
              // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
            });
            }else {
               myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/outLineKeRanQi.png"), new BMap.Size(30, 30), {
              // offset: new BMap.Size(10, 25), // 指定定位位置
              // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
            });
            }
             a = new BMap.Marker(pt, {
              icon: myIcon
            })
          }else {
              if (item.isOnline){
                //其他离线
               myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/onLineOther.png"), new BMap.Size(30, 30), {
              // offset: new BMap.Size(10, 25), // 指定定位位置
              // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
            });
            // a = new BMap.Marker(pt)
            }else {
               myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/outLineOther.png"), new BMap.Size(30, 30), {
              // offset: new BMap.Size(10, 25), // 指定定位位置
              // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
            });
            }
             a = new BMap.Marker(pt, {
              icon: myIcon
            })
          }
          markers.push(a);
          a.addEventListener("click", function (e) {
            var p = e.target;
            var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
            // 创建信息窗口对象
            var opts = {
              width: 250, // 信息窗口宽度
              height: 280, // 信息窗口高度
              enableMessage: true //设置允许信息窗发送短息
            };
            let str = ''
            str = `<h4 class="title" style="color:#009688">${item.userName}(C19083100288)</h4><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-s-flag" style="width:20px;color:#51AAA2"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">管理方：</span>
                            <span class="value" style="color:#000">${item.orgName}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-position" style="width:20px;color:#E7A485"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">安装位置：</span>
                            <span class="value" style="color:#000">${item.installLocation}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-location-information" style="width:20px;color:#DCBE75"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">IMEI：</span>
                            <span class="value" style="color:#000">${item.imei}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-time" style="width:20px;color:#8B966C"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">安装时间：</span>
                            <span class="value" style="color:#000">${item.installTime}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-video-play" style="width:20px;color:#379D94"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">注册时间：</span>
                            <span class="value" style="color:#000">${item.registTime}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-video-pause" style="width:20px;color:#75A6BB"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">创建时间：</span>
                            <span class="value" style="color:#000">${item.createTime}</span>
                          </div><br />`
            var infoWindow = new BMap.InfoWindow(
              str, opts);
            //开启信息窗口
            map.openInfoWindow(infoWindow, point);
          });
        }

        // }
      })
      /*    for (var i = 0; i < MAX; i++) {

             } */
      //最简单的用法，生成一个marker数组，然后调用markerClusterer类即可。
      // var st = [{
      //     url: "m0.png",
      //     size: new BMap.Size(53, 53)
      //   },
      //   {
      //     url: "m1.png",
      //     size: new BMap.Size(56, 56)
      //   },
      //   {
      //     url: "m2.png",
      //     size: new BMap.Size(66, 66)
      //   },
      //   {
      //     url: "m3.png",
      //     size: new BMap.Size(78, 78)
      //   },
      //   {
      //     url: "m4.png",
      //     size: new BMap.Size(90, 90)
      //   }
      // ];
      var markerClusterer = new BMapLib.MarkerClusterer(map, {
        markers: markers,
        // styles: st
      });
      var TextIconOverlay = new BMapLib.TextIconOverlay();

      //点聚合=====================
       map.setMapType(that.mapType * 1 == 1 ? BMAP_NORMAL_MAP : BMAP_SATELLITE_MAP, () => {
        })
    },
    // 地图
    //拖拉
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move' // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item) {
      let flag = false
      e.dataTransfer.effectAllowed = "move" //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return
      }
      const newItems = [...this.checkedItems]
      const src = newItems.indexOf(this.dragging)
      const dst = newItems.indexOf(item)
      if (!flag) {
        let dragItem = newItems[src]
        let dstItem = newItems[dst]
        newItems[src] = dstItem
        newItems[dst] = dragItem
      }
      this.checkedItems = newItems
      flag = true
    },

    //拖拉
  },
}
</script>

<style lang="scss" scoped>
.homeView {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #0C1A35;

  .top {
    width: 100%;
    height: 50px;
    background: url(../../assets/img/bigScreen/header.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    z-index: 99;
    .title {
      font-family: "HYWenHEI";
      text-align: center;
      font-size: 28px;
      line-height: 50px;
      color: #00E5FF;

      background-image: linear-gradient(0deg, #0284D1 0%, #00E5FF 100%);
      background-clip: text;
      text-fill-color: transparent;
      // 前缀
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: -webkit-linear-gradient(bottom, #0284D1, #00E5FF);
    }

    .top-right {
      position: absolute;
      top: 20px;
      right: 10px;
      font-size: 22px;
      color: #fff;
      font-size: 20px;
      color: #fff;

      i {
        cursor: pointer;
        margin-right: 20px;
      }

    }

    .right :hover {
      cursor: pointer;
    }
  }

  #map_container {
    width: 100%;
    height: 100%;
    // background-color: pink;
    //    .anchorTR {
    //   // margin-top: 50px !important;
    //   margin-right: 100px;
    // }
  }

  .dragCon {
    position: absolute;
    top: 5%;
    left: 0;
    float: left;
    width: 100%;
    height: 90%;
    margin-top: 2%;
    z-index: 100;

    .dragConCon {
      width: 100%;
      height: 100%;
      position: relative;

      .container {
        // position: absolute;
        // top: 59%;
        // transform: translateY(-50%);
        padding: 0 20px;
        box-sizing: border-box;
        width: 100%;
        height: 810px;
        display: flex;
        justify-items: space-around;
        align-content: space-between;
        flex-direction: column;
        flex-wrap: wrap;

        .item {
          // margin-top: 20px;
          width: 300px;
          height: 220px;
          // background-color: aqua;

          img {
            width: 300px;
            height: 220px;
          }
        }
      }
    }

    // background-color: aqua;
    // z-index: 100;
  }

  /* .mainCenter {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 100px;
    // border: 1px solid red;
    width: 500px;
    height: 100px;
    z-index: 11;
    display: flex;
    background-color: rgba(128, 128, 128, 0.3);
    color: #fff;
    text-shadow: 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0), 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0);

    li {
      flex: 1;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      height: 100%;
      text-align: center;

      .centerTop {
        height: 40px;
        line-height: 40px;
        // flex: 1;
        font-size: 14px;
      }

      .centerBottom {
        // flex: 2;
        height: 70px;
        line-height: 70px;
        font-size: 30px;
      }

    }
  } */
  .total-center {
    position: absolute;
    top: 68px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 11;
    color: #fff;
    li {
      width: 110px;
      height: 60px;
      display: inline-block;
      background: url(../../assets/img/bigScreen/total-box.png) no-repeat;
      background-size: 100% 100%;
      margin-right: 2px;
      margin-left: 2px;
      img {
        width: 30px;
        margin-left: 10px;
        margin-right: 5px;
      }
      .right {
        vertical-align: -10px;
        margin-top: 12px;
        display: inline-block;
        font-size: 12px;
        color: #02D9FD;
        .num {
          font-size: 18px;
          font-family: 'PMZD';

        }
      }
    }
  }  

  // .save {
  //   position: absolute;
  //   top: 25px;
  //   transform: translateY(-50%);
  //   right: 60px;
  //   z-index: 100;
  //   font-size: 20px;
  //   color: #fff;
  // }

  // .close {
  //   position: absolute;
  //   top: 25px;
  //   transform: translateY(-50%);
  //   right: 20px;
  //   z-index: 100;
  //   font-size: 20px;
  //   color: #fff;
  // }

  .viewClass {
    position: absolute;
    top: 25px;
    transform: translate(-50%, -50%);
    right: 50%;
    z-index: 100;
    font-size: 20px;
    color: #fff;
    text-shadow: 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0), 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0);
  }
}
</style>
<style lang="scss">
.homeView {
    .anchorBL {
    display: none;
  }
}
</style>
